<template>
  <RankDivisionPicker
    :type="'currentRank'"
    item-key="rankedWinBoost"
    :title="$t('calculators_common.current_rank')"
    class="full-width"
    :show-server="true"
  />
  <RangePicker
    :title="$t('calculators_common.number_of_wins')"
    :description="$t('calculators_common.select_number_of_wins')"
    type="wins"
  />
  <option-picker />
</template>

<script setup>
import RangePicker from "../commonpickers/RangePicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";
import { onMounted, watch } from "vue";

const {
  getDetails,
  setDetails,
  setPackExtraOptions,
  setServer,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setCalculating,
} = useCheckoutStore();

const { getGame, getGamePack, getGameRanks } = useGameStore();

const handleDetails = () => {
  clearCheckout();
  if (getGameRanks.length > 0) {
    setDetails({
      currentDivision: getGameRanks[1]?.divisions[0]?.id,
      currentDivisionTitle: getGameRanks[1]?.divisions[0]?.title,
      currentRank: getGameRanks[1]?.id,
      currentRankTitle: getGameRanks[1]?.title,
      numberOfWins: 1,
    });
  }
  setPlatform({
    platform: 1,
  });
  setServer("65");

  // setPackExtraOptions({
  //   lpGain: 19,
  //   queueType: 17,
  // });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});
watch(
  () => getGameRanks,
  (newVal) => {
    setDetails({
      currentDivision: newVal[1]?.divisions[0]?.id,
      currentDivisionTitle: newVal[1]?.divisions[0]?.title,
      currentRank: newVal[1]?.id,
      currentRankTitle: newVal[1]?.title,
      numberOfWins: 1,
    });
  }
);
</script>
